import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import API_URL from '../../config';

// Text checker, client side (October 2026). While the recruiter types, ask the server to check the
// draft about a second after they stop typing, so the result is already cached when they hit Send
// and the send doesn't wait. The send endpoint does the real check either way (utils/textCheck.js);
// this hook only warms it and surfaces "this may be unclear" early.
const DEBOUNCE_MS = 1200;

export default function useTextCheck(text) {
  const [unclear, setUnclear] = useState(null); // question string when the draft looks unclear
  const lastChecked = useRef('');

  useEffect(() => {
    const t = (text || '').trim();
    if (t !== lastChecked.current) setUnclear(null);
    if (!t || t.split(/\s+/).length < 3) return undefined;
    const timer = setTimeout(async () => {
      lastChecked.current = t;
      try {
        const { data } = await axios.post(`${API_URL}/api/text-check`, { text: t },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
        if (data.status === 'ready' && data.unclear && lastChecked.current === t) setUnclear(data.question || 'This text may be unclear.');
      } catch { /* the send will check again */ }
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [text]);

  return { unclear };
}
